export default __webpack_public_path__ + "static/media/smile.4718688e.svg";